const API_BASE = import.meta.env.VITE_API_BASE;

/**
 * Submit a feedback message from a logged-in user.
 * @param {{ message: string, uid: string|null, name: string|null, email: string|null }} payload
 * @returns {Promise<void>} Resolves on success, rejects with Error on failure.
 */
export async function submitFeedback(payload) {
  const res = await fetch(`${API_BASE}/feedback`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || `Request failed (${res.status})`);
  }
}
